export default "__VITE_ASSET__B8LhnF0I__"